import { useEffect, useState } from 'react';
import AppButton from '../atoms/AppButton';
import { IconWhatsapp } from '../atoms/Icon';
import { cta } from '../content/site';
import { trackEvent } from '../utils/analytics';

/** Só em celular (a classe é escondida em telas maiores via CSS) e só depois
 *  do primeiro scroll: sobre o herói ela duplicaria o CTA que já está ali. */
function StickyWhatsapp() {
  const [visivel, setVisivel] = useState(false);

  useEffect(() => {
    const aoRolar = () => setVisivel(window.scrollY > window.innerHeight * 0.6);
    aoRolar();
    window.addEventListener('scroll', aoRolar, { passive: true });
    return () => window.removeEventListener('scroll', aoRolar);
  }, []);

  return (
    <div className={`sticky-whatsapp d-lg-none${visivel ? ' is-visible' : ''}`}>
      <AppButton
        href={cta.principal.href}
        variant="whatsapp"
        className="w-100"
        onClick={() => trackEvent('click_whatsapp', { posicao: 'sticky' })}
      >
        <IconWhatsapp size={18} />
        Falar no WhatsApp
      </AppButton>
    </div>
  );
}

export default StickyWhatsapp;
